import Handler from "../Handler";

class SendEmojiAckHandler extends Handler {
  execute(data) {
    let receivedData = JSON.parse(data);
    this.service.processEmojiOnTable(receivedData);
  }
}

export default SendEmojiAckHandler;
// sendEmojiA#{“playerName”:””,”tableId”:””,”emojiId”:””,”statusCode”:200} to that player
